export class Task {
    id = ""
    customId = ""
    name = ""
    markdown_description = ""
    orderIndex = 1
    url = "";
    customMap = {};
    /**
     * @type {TaskList}
     */
    parent;
    /**
     * @type {Customer}
     */
    customer;

    /**
     * @type {Date}
     */
    startDate;

    /**
     * @type {Date}
     */
    dueDate;
}